/** Shared table + date-pill styles for Timeline & Design change-request milestone tabs */

export const milestoneCrTablePaperSx = {
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow: "none",
  backgroundColor: "#fff",
  "& .MuiTableCell-root": {
    borderBottom: "none",
    padding: "18px 20px",
    verticalAlign: "middle",
  },
  "& .MuiTableHead .MuiTableCell-root": {
    borderBottom: "none",
    backgroundColor: "#fff",
  },
  "& .MuiTableRow-root:last-child .MuiTableCell-root": {
    borderBottom: "none",
  },
};

export const milestoneCrHeadCellSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#949DAA",
};

export const milestoneCrCheckboxSx = {
  p: 0.5,
  color: "#cbd5e1",
  "&.Mui-checked": { color: "#4D6BF6" },
  "&.Mui-disabled": { color: "#cbd5e1" },
  "&.Mui-disabled.Mui-checked": { color: "#4D6BF6" },
};

/** Date shown inside a white pill; `highlight` uses a light blue border when dates changed (timeline). */
export const getDatePillSx = (highlight = false) => ({
  display: "inline-block",
  px: "14px",
  py: "8px",
  borderRadius: "9999px",
  backgroundColor: "#fff",
  border: highlight ? "1px solid #91d5ff" : "1px solid #E4E5E7",
  fontSize: "14px",
  fontWeight: 500,
  color: "#0d0d0e",
  minWidth: "112px",
  textAlign: "center",
  boxSizing: "border-box",
});

export const milestoneCrStatusDotSx = (bg = "#fa8c16") => ({
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  backgroundColor: bg,
  flexShrink: 0,
});
